import React, { Component } from "react";
import EquipmentItem from "../EquipmentItem";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';

import { getEquipment, getMoreEquipment, deleteEquipment } from '../../../actions/equipmentActions';
import { getHeader } from "../../../helper";

class ViewEquipment extends Component {

    constructor() {
        super();

        this.state={
            switchLinkText: true
        }
    }

    componentWillMount() {
        let headers = getHeader();
        const { dispatch, session } = this.props;
        const { id } = session.currentUser;   

        dispatch(getEquipment({
            params: {user_id: id},
            headers: headers
        }));
    }

    componentWillReceiveProps(nextProps) {
        // При удалении
        if(this.props.equipments.isDeleting !== nextProps.equipments.isDeleting){
            this.setState({
                switchLinkText: true
            });
        }
    }

    switchEditOrList(event) {
        this.setState({
            switchLinkText: !this.state.switchLinkText
        })

        event.preventDefault();
    }

    getMoreRecords(record_id) {
        if(!record_id) return false;

        const headers = getHeader();
        const { dispatch, session } = this.props;
        const { id } = session.currentUser;

        dispatch(getMoreEquipment({
            params: {id__lt: record_id, user_id: id},
            headers: headers
        }));
    }

    // Удаление выбраной позиции из сервера
    delete(elem) {
        const { dispatch } = this.props;

        this.props.toggleDeleteModal(elem)

        // dispatch(deleteEquipment(
        //     id,
        //     {is_deleted: true}
        // ));
    }

    render() {
        const { equipments, /*getMoreRecords,*/ session } = this.props;
        const { isFetching, isFetchingMore } = equipments;
        const { results } = equipments.data;
        const moreOrders = equipments.data.next || null;
        
        return (
            <div className="menu-content-equipment menu-content-item screen-bottom-block">
                <div className="rounded-white-block">
                    <div className="white-block-top search-top-panel header-tabs tab-nav">
                        <h3>Список оборудования</h3>
                        <Link className="edit-equipment" to={`/profile/${session.currentUser.id}/equipment/create`}>
                            Cоздать оборудование
                        </Link>
                        <a href="" className="edit-equipment" onClick={(event) => { this.switchEditOrList(event) }}>
                            {this.state.switchLinkText ? "Редактировать список" : "Вернуться в список"}
                        </a>
                    </div>
                    <div className="white-block-content">
                        <ul className="items-list">
                            {
                                isFetching ?
                                <li className="list-item" >Загружается...</li>
                                :
                                    results.length ?
                                    results.map((elem, index) => {
                                        return (
                                            <EquipmentItem
                                                key={index}
                                                id={elem.id}
                                                title={elem.title}
                                                width={elem.width}
                                                height={elem.height}
                                                user={elem.user}
                                                cam_type={elem.cam_type}
                                                image={elem.image}
                                                switchEditDelete={this.state.switchLinkText}
                                                delete={() => this.delete.bind(this, elem)}
                                            />
                                        );
                                    })
                                    : <li className="list-item" >Оборудований нет</li>
                            }
                        </ul>
                        <div className="tab-content tab-content2 hidden">
                        </div>
                    </div>
                </div>
                {
                    moreOrders && isFetching ?
                    <div className="big-button without-shadow button-action" style={{height:"auto", textAlign:"center",marginTop:"30px",marginBottom:"30px"}}>
                        <button
                            className={isFetchingMore ? 'disabled' : ''}
                            onClick={() => this.getMoreRecords(results.slice(-1)[0].id)}>{isFetchingMore ? 'Загружается...' : 'Загрузить еще'}</button>
                    </div>
                    : ''
                }
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(ViewEquipment);


// WEBPACK FOOTER //
// ./src/components/Profile/SubEquipment/ViewEquipment.js